var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 80 80",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z",
    fill: "#E6EEF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0312 42.6875C31.0312 37.8027 35.0352 33.7188 40 33.7188C44.8848 33.7188 48.9688 37.8027 48.9688 42.6875C48.9688 47.6523 44.8848 51.6562 40 51.6562C35.0352 51.6562 31.0312 47.6523 31.0312 42.6875ZM40 37.5625C37.1172 37.5625 34.875 39.8848 34.875 42.6875C34.875 45.5703 37.1172 47.8125 40 47.8125C42.8027 47.8125 45.125 45.5703 45.125 42.6875C45.125 39.8848 42.8027 37.5625 40 37.5625ZM48.4883 24.8301L49.3691 27.3125H55.375C58.1777 27.3125 60.5 29.6348 60.5 32.4375V52.9375C60.5 55.8203 58.1777 58.0625 55.375 58.0625H24.625C21.7422 58.0625 19.5 55.8203 19.5 52.9375V32.4375C19.5 29.6348 21.7422 27.3125 24.625 27.3125H30.5508L31.4316 24.8301C31.9121 23.3086 33.3535 22.1875 35.0352 22.1875H44.8848C46.5664 22.1875 48.0078 23.3086 48.4883 24.8301ZM24.625 31.1562C23.9043 31.1562 23.3438 31.7969 23.3438 32.4375V52.9375C23.3438 53.6582 23.9043 54.2188 24.625 54.2188H55.375C56.0156 54.2188 56.6562 53.6582 56.6562 52.9375V32.4375C56.6562 31.7969 56.0156 31.1562 55.375 31.1562H46.5664L44.8848 26.0312H35.0352L33.3535 31.1562H24.625Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/frame2.d5edc0761dabff335e1783be9c0150ad.svg";
export { ForwardRef as ReactComponent };